import { FINGERPRINT_SAVE } from "../constants/actionTypes";

const doSaveFingerprint = fingerprint => ({
  type: FINGERPRINT_SAVE,
  payload: fingerprint,
});

export { doSaveFingerprint };
